export default "__VITE_ASSET__DEGxS0Wp__"